<template>
  <div v-if="is_create_btn">
    <a-button
      size="small"
      type="primary"
      :disabled="is_create_btn_disabled"
      @click="handleAdd"
    >
      <plus-outlined />
      {{ pageConfig.titleList.addModalTitle }}
    </a-button>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, ref } from 'vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import modalBox from 'liyu-pc-base/components/form-modal/modal-tools';
import { getApiData } from 'liyu-pc-base/api/api-model';
import { useI18n } from 'vue-i18n';
import { PageConfig } from '../typing';
import { checkCondition } from 'liyu-pc-base/utils/function';
import { useUserStore } from 'liyu-pc-base/init-plugin';

interface Props {
  pageConfig: PageConfig;
  modalType: string;
  app_flag: string;
  dataSource: any[];
  selectedRowKeys: [] | null;
}
const props = withDefaults(defineProps<Props>(), {});
const userStore = useUserStore();
const emit = defineEmits(['ok']);
const { t } = useI18n();
const configLoading = ref(false);
const handleAdd = () => {
  const tempModal = reactive({
    open: true,
    loading: false,
    configLoading: configLoading,
    title: props.pageConfig.titleList.addModalTitle,
    form: props.pageConfig.formModalConfig,
    ok: async (data: any) => {
      tempModal.loading = true;
      try {
        await getApiData(
          {
            ...data,
          },
          props.pageConfig.addData,
        );
        message.success(t('创建成功'));
        emit('ok');
      } finally {
        tempModal.loading = false;
      }
    },
  });
  modalBox(tempModal);
};
const is_create_btn_disabled = computed(() =>
  check_btn_disabled(props.pageConfig.titleList.create_config),
);
const check_btn_disabled = (btn_config: any) => {
  let isDisabled = false;
  if (typeof btn_config?.is_disabled === 'function') {
    isDisabled = btn_config.is_disabled({
      dataSource: props.dataSource,
      selectedRowKeys: props.selectedRowKeys,
    });
  }
  if (typeof btn_config?.is_disabled === 'boolean') {
    isDisabled = btn_config.is_disabled;
  }
  if (btn_config?.disabled_condition && btn_config?.disabled_condition.length > 0) {
    isDisabled = checkCondition({
      dataSource: props.dataSource,
      selectedRowKeys: props.selectedRowKeys,
      conditions: btn_config.disabled_condition,
    });
  }
  return isDisabled;
};

const is_create_btn = computed(
  () =>
    userStore.HAS_CREATE_BTN(props.pageConfig) &&
    check_btn_show(props.pageConfig.titleList.create_config),
);
const check_btn_show = (btn_config: any) => {
  if (btn_config?.show_condition && btn_config?.show_condition.length > 0) {
    return checkCondition({
      dataSource: props.dataSource,
      selectedRowKeys: props.selectedRowKeys,
      conditions: btn_config.show_condition,
    });
  }
  if (typeof btn_config?.is_show === 'function') {
    return btn_config.is_show({
      dataSource: props.dataSource,
      selectedRowKeys: props.selectedRowKeys,
    });
  }
  if (typeof btn_config?.is_show === 'boolean') {
    return btn_config.is_show;
  }
  return true;
};
</script>
